module.exports = __webpack_public_path__ + "files/a35.13438225.pdf";